import React, {useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import {ActionButton, FormGroup, useAlert} from "./components/FormComps"
import {useIntlEx} from "./components/IntlUtils.js"
import {default as Select} from "react-select"
import {useSolv} from "./components/SolvProvider";
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {mkHref} from "./components/AccountUtils";
import {usePaymentMethodOpts} from "./components/CreditTransactionUtils";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("CommissionStatementSettleDialog")

export default function CommissionStatementSettleDialog(props)  {

  const { api, session, setBusy } = useSolv()
  const { intl } = useIntlEx()

  const [alert, setAlert] = useAlert()

  const {paymentMethodOpts, findPaymentMethodOpt} = usePaymentMethodOpts(f => {
    if (["BANK", "CASH", "CRYPTO", "OTHER", "PAYPAL", "TEST", "WISE"].includes(f.value)) {
      return f
    }
    else {
      return null
    }
  })

  const [paymentMethod, setPaymentMethod] = useState(findPaymentMethodOpt("BANK"))
  const [refInfo, setRefInfo] = useState(null)
  const [invoiceNo, setInvoiceNo] = useState(null)
  const [touched, setTouched] = useState(null)

  async function handleSettleClick() {

    setBusy(intl.msg("working"))

    try {

      let payload = {
        invoiceInfo: {
          invoiceNo: invoiceNo
        },
        paymentInfo: {
          paymentMethod: paymentMethod.value,
          refInfo: refInfo,
        },
        invokedById: session.user.userId
      }

      // log.debug("settleCommissionStatement: payload=", payload)

      const res = await api.settleCommissionStatement(props.commissionStatementId, payload)

      // log.debug("settleCommissionStatement: data=", res)

      window.location = mkHref({suffix: `/commissions/${props.commissionStatementId}`, tenant: props.tenant})
    }
    catch (error) {
      // log.debug("Error: error=", error)
      handleError(error)
    }
    finally {
      setBusy(null)
    }
  }

  function handleError(error) {
    if (error && error.code) {
      // log.debug("handleError: error=", error.code)
      const code = error.code
      switch (code) {
        case "NOT_FOUND":
          setAlert({type: "error", text: intl.msg("credit_transaction_settle_error_not_found")})
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed")})
          break
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function handleInvoiceNoChange(e) {
    setInvoiceNo(e.target.value)
    setTouched(true)
  }

  function handleRefInfoChange(e) {
    setRefInfo(e.target.value)
    setTouched(true)
  }

  function handlePaymentMethodChange(v) {
    setPaymentMethod(v)
    setTouched(true)
  }

  function handleOpenDialog() {
    setAlert(null)
  }

  function handleCloseDialog() {
    closeDialog("dlg_commission_statement_settle")
  }


  return (

    props.tenant &&
      <ModalDialog
        dialogId="dlg_commission_statement_settle"
        size="lg" keyboard={"true"} backdrop={props.backdrop || "static"}
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}
      >

        <ModalDialog.Header
          title={intl.msg("commission_statement_settle_title")} description={intl.msg("commission_statement_settle_subtitle")}
          alert={alert}
        />

        <ModalDialog.Body>

          <FormGroup>
            <FormGroup.Label htmlFor="inp_invoiceNo" text={intl.msg("invoice_no")} description={intl.msg("commission_statement_settle_invoice_no_description")}/>
            <FormGroup.Controls>
              <input id="inp_invoiceNo" name="invoiceNo" type="text" className="form-control" value={invoiceNo} disabled={false} onChange={handleInvoiceNoChange} autoComplete="off"/>
            </FormGroup.Controls>
          </FormGroup>

          <FormGroup className="mt-2">
            <FormGroup.Label htmlFor="inp_paymentMethod" text={intl.msg("payment_method")} description={intl.msg("commission_statement_settle_payment_method_description")}/>
            <FormGroup.Controls>
              <div style={{width: "200px"}}>
                <Select
                  id="inp_paymentMethod"
                  className="react-select"
                  classNamePrefix="react-select"
                  value={paymentMethod}
                  options={paymentMethodOpts}
                  onChange={handlePaymentMethodChange}
                />
              </div>

            </FormGroup.Controls>
          </FormGroup>

          <FormGroup>
            <FormGroup.Label htmlFor="inp_refInfo" text={intl.msg("payment_ref_info")} description={intl.msg("commission_statement_settle_payment_ref_info_description")}/>
            <FormGroup.Controls>
              <input id="inp_refInfo" name="refInfo" type="text" className="form-control" value={refInfo} disabled={false} onChange={handleRefInfoChange} autoComplete="off"/>
            </FormGroup.Controls>
          </FormGroup>

        </ModalDialog.Body>

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            <ActionButton name="cancel" onClick={handleCloseDialog}/>
            <ActionButton icon="ok" msg="settle" flavor="primary" disabled={alert || invoiceNo === null || invoiceNo?.trim()?.length === 0|| refInfo === null || refInfo?.trim()?.length === 0} onClick={handleSettleClick}/>
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>

      </ModalDialog>
  )
}